import { Stack } from "@mui/material";
import React from "react";
import { RightPanel } from "../../components/RightPanel";
import { ManageWhatsAppTemplate } from "./ManageWhatsAppTemplate";
import { IWhatsAppTemplateData } from "../../redux/whatsappTemplate/whatsappTemplate.types";
interface IManageWhatsAppTemplateRightPanelProps {
  open: boolean;
  onClose: () => void;
  onSaveSuccess: (templateData: IWhatsAppTemplateData) => void;
  isFromRecommendedFromRightpanel?: boolean;
  recommendedTemplateDataFromRightpanel?: IWhatsAppTemplateData;
}

export const ManageWhatsAppTemplateRightPanel: React.FC<
  IManageWhatsAppTemplateRightPanelProps
> = (props) => {
  const {
    open,
    onClose,
    onSaveSuccess,
    recommendedTemplateDataFromRightpanel,
    isFromRecommendedFromRightpanel,
  } = props;

  return (
    <>
      <RightPanel
        heading={"Create Meta Template"}
        open={open}
        width="65%"
        onClose={onClose}
        actionButtons={() => {
          return (
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              spacing={2}
            >
              <Stack direction={"row"} spacing={2}>
                {/* <Button variant="contained" onClick={onClose}>
                  <Close sx={{ fontSize: 18, mr: 0.5 }} />
                  Close
                </Button> */}
                {/* {actions} */}
              </Stack>
            </Stack>
          );
        }}
      >
        <ManageWhatsAppTemplate
          onSaveSuccess={(templateData) => {
            onSaveSuccess(templateData);
          }}
          fromRightPanel
          isFromRecommendedFromRightpanel={isFromRecommendedFromRightpanel}
          recommendedTemplateDataFromRightpanel={
            recommendedTemplateDataFromRightpanel
          }
        />
      </RightPanel>
    </>
  );
};
